import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getTenderItemsDisplay = createAsyncThunk(
    "getTenderItemsDisplay",
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tenders/${tenderId}`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const TenderItemDisplaySlice = createSlice({
    name: "TenderItemDisplaySlice",
    initialState: {
        loading: {}, // Keyed by tenderId
        data: {},    // Keyed by tenderId
        error: {},   // Keyed by tenderId
    },
    reducers: {
        resetTenderItemDisplay: (state, action) => {
            const tenderId = action.payload;
            if (tenderId) {
                delete state.data[tenderId];
                delete state.loading[tenderId];
                delete state.error[tenderId];
            } else {
                state.loading = {};
                state.data = {};
                state.error = {};
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTenderItemsDisplay.pending, (state, action) => {
                const tenderId = action.meta.arg;
                state.loading[tenderId] = true;
                state.error[tenderId] = null;
            })
            .addCase(getTenderItemsDisplay.fulfilled, (state, action) => {
                const tenderId = action.meta.arg;
                state.loading[tenderId] = false;
                state.data[tenderId] = action.payload?.data;
            })
            .addCase(getTenderItemsDisplay.rejected, (state, action) => {
                const tenderId = action.meta.arg;
                state.loading[tenderId] = false;
                state.error[tenderId] = action.payload;
            });
    },
});

export const { resetTenderItemDisplay } = TenderItemDisplaySlice.actions;
export default TenderItemDisplaySlice.reducer;
